// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"home_skeletonContainer__PUXta","title":"home_title__x7j7h","skeleton":"home_skeleton__Jlrpn","container":"home_container__+9HJC","content":"home_content__-INpw"};